import { useV2Flag } from "@/v2/hooks/useV2Flag";
import { V2Shell } from "@/v2/components/V2Shell";
import { Header as V2Header } from "@/v2/components/layout/Header";
import V1Header from "./V1Header";

const Header = () => {
  const useV2Nav = useV2Flag("nav");
  if (useV2Nav) {
    return (
      <V2Shell>
        <V2Header />
      </V2Shell>
    );
  }
  return <V1Header />;
};

export default Header;
